module.exports = __webpack_public_path__ + "static/aboutFabricsthan2-6ad414e917ee5fbd8406e3fff8c6c631.png";